import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';


import { HighchartsChartModule } from 'highcharts-angular';

import { AppRoutingModule } from './app-routing.module';

import { TranslatePipe, TranslationService } from './translate';
import { GoogleAnalyticsEventsService } from "./google-analytics-events.service";

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { NotSupportedComponent } from './not-supported/not-supported.component';
import { SettingsComponent } from './settings/settings.component';
import { NoContentComponent } from './no-content/no-content.component';
import { Step2Component } from './step2/step2.component';
import { ResultsComponent } from './results/results.component';
import { DaughterEligibilityComponent } from './eligibility/daughter/daughter.component';
import { FatherEligibilityComponent } from './eligibility/father/father.component';
import { HusbandEligibilityComponent } from './eligibility/husband/husband.component';
import { MotherEligibilityComponent } from './eligibility/mother/mother.component';
import { SonEligibilityComponent } from './eligibility/son/son.component';
import { WifeEligibilityComponent } from './eligibility/wife/wife.component';

import { WifeDivorcedComponent } from './wife/divorced/divorced.component';
import { WifeTempComponent } from './wife/temp/temp.component';

import { HttpClientModule } from '@angular/common/http';
import { SiblingsInfoComponent } from './level2-inheritors/siblings/siblings.component';
import { CounterComponent } from './counter/counter.component';
import { WebviewComponent } from './webview/webview.component';

@NgModule({
  declarations: [
    AppComponent,
    TranslatePipe,
    HomeComponent,
    AboutComponent,
    NotSupportedComponent,
    SettingsComponent,
    NoContentComponent,
    Step2Component,
    ResultsComponent,
    DaughterEligibilityComponent,
    FatherEligibilityComponent,
    HusbandEligibilityComponent,
    MotherEligibilityComponent,
    SonEligibilityComponent,
    WifeEligibilityComponent,
    WifeDivorcedComponent,
    WifeTempComponent,
    SiblingsInfoComponent,
    CounterComponent,
    WebviewComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HighchartsChartModule,
    HttpClientModule,
    FormsModule
  ],
  providers: [
    TranslationService,
    GoogleAnalyticsEventsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
